<template>
  <BaseLayout>
    <div @click="$router.push({name: 'environment', params: { id: environment }})" class="w-6 h-6 m-4 cursor-pointer" title="Back to environment">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd"
              d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
              clip-rule="evenodd"/>
      </svg>
    </div>
    <div class="text-left px-4">
      <div>Environment name: <span class="font-bold">{{ environment }}</span></div>
    </div>
    <div class="text-left px-4 pt-4">
      <div>Firewalls:</div>
    </div>
    <div v-if="loading" class="firewall-container px-4 pt-4">Loading firewalls...</div>
    <div v-else-if="error" class="error">{{ error }}</div>
    <div v-else class="firewall-container px-4 pt-4">
      <div v-for="(firewall, index) in firewalls" :key="index">
        <div v-if="firewall.rules" class="text-left">{{ firewall.app }}</div>
        <div v-else class="text-left text-gray-500 line-through">{{ firewall.app }}</div>
        <textarea
          v-model="firewall.rules"
          class="firewall-textarea"
          :disabled="firewall.rules == null"
        ></textarea>
      </div>
    </div>
    <div class="text-left px-4 pt-4">
      <button
        type="button"
        class="bg-blue-800 hover:bg-blue-700 text-white font-semibold py-2 px-4"
        @click="saveAll">
        Save all
      </button>
      <div v-if="saving">Saving...</div>
      <div v-if="saveError != null && saveError !== ''" class="pt-4 text-red-500">{{ saveError }}</div>
    </div>
  </BaseLayout>
</template>

<script>
import {defineComponent, onMounted, ref} from "@vue/composition-api"
import {getFirewalls, setFirewalls} from "@/data/repos/firewalls"
import BaseLayout from "@/components/layout/BaseLayout.vue"

export default defineComponent({
  components: {BaseLayout},
  props: {
    environment: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const firewalls = ref([])
    const loading = ref(true)
    const error = ref(null)
    const saving = ref(false)
    const saveError = ref('')

    const fetchFirewalls = async() => {
      try {
        loading.value = true
        firewalls.value = (await getFirewalls(props.environment)).payload
        loading.value = false
      } catch (e) {
        error.value = e.message
        loading.value = false
      }
    }

    const saveAll = async() => {
      try {
        saving.value = true
        saveError.value = null
        const resp = await setFirewalls(props.environment, firewalls.value)
        if (resp.ok) {
          await fetchFirewalls()
        } else {
          console.info("resp: ", resp)
          saveError.value = resp.response.statusText
        }
      } catch (e) {
        saveError.value = e.message
      } finally {
        saving.value = false
      }
    }

    onMounted(fetchFirewalls)

    return {
      firewalls,
      loading,
      error,
      saveAll,
      saving,
      saveError,
    }
  },
})
</script>

<style scoped>
.error {
  color: #ff0000;
}

.firewall-container {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}

.firewall-textarea {
  flex: 1;
  min-width: 0;
  padding: 4pt;
  line-height: 1.5;
  width: 32ch;
  height: 500px;
  border: 1px solid #d3d3d3;
}
</style>
